var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEyeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2333_264680",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2333_264680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 18.834L13.0002 15.3757C12.5141 15.5284 12.0245 15.643 11.5314 15.7194C11.0384 15.7958 10.5279 15.834 10.0002 15.834C7.90294 15.834 6.03489 15.2541 4.396 14.0944C2.75711 12.9347 1.56961 11.4312 0.833496 9.58398C1.12516 8.84787 1.49322 8.16385 1.93766 7.5319C2.38211 6.89996 2.88905 6.33398 3.4585 5.83398L1.16683 3.50065L2.3335 2.33398L17.6668 17.6673L16.5002 18.834ZM10.0002 13.334C10.1529 13.334 10.2953 13.327 10.4272 13.3132C10.5592 13.2993 10.7016 13.2715 10.8543 13.2298L6.35433 8.72982C6.31266 8.8826 6.28489 9.02496 6.271 9.1569C6.25711 9.28885 6.25016 9.43121 6.25016 9.58398C6.25016 10.6257 6.61475 11.5111 7.34391 12.2402C8.07308 12.9694 8.9585 13.334 10.0002 13.334ZM16.0835 13.709L13.4377 11.084C13.5349 10.8479 13.6113 10.6083 13.6668 10.3652C13.7224 10.1222 13.7502 9.86176 13.7502 9.58398C13.7502 8.54232 13.3856 7.6569 12.6564 6.92773C11.9272 6.19857 11.0418 5.83398 10.0002 5.83398C9.72239 5.83398 9.46197 5.86176 9.21891 5.91732C8.97586 5.97287 8.73627 6.05621 8.50016 6.16732L6.37516 4.04232C6.94461 3.80621 7.52794 3.62912 8.12516 3.51107C8.72239 3.39301 9.34739 3.33398 10.0002 3.33398C12.0974 3.33398 13.9654 3.91385 15.6043 5.07357C17.2432 6.23329 18.4307 7.73676 19.1668 9.58398C18.8474 10.4034 18.4272 11.1638 17.9064 11.8652C17.3856 12.5666 16.7779 13.1812 16.0835 13.709ZM12.2293 9.87565L9.72933 7.37565C10.1182 7.30621 10.4759 7.33746 10.8022 7.4694C11.1286 7.60135 11.4099 7.79232 11.646 8.04232C11.8821 8.29232 12.0522 8.58051 12.1564 8.9069C12.2606 9.23329 12.2849 9.55621 12.2293 9.87565Z",
    fill: "#DDDDDD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEyeOff);
export default __webpack_public_path__ + "static/media/icEyeOff.110b2bc2fe1e4115d4cc7b319fba2c8c.svg";
export { ForwardRef as ReactComponent };